<template lang="pug">
  .table-x
    .table-x__header
      .table-x__header-col {{ 'base.name' | translate }}
      .table-x__header-col {{ 'base.kg_per_day' | translate }}
      .table-x__header-col {{ 'base.on_stock' | translate }}
      .table-x__header-col {{ 'base.mixing' | translate }}
      .table-x__header-col {{ 'base.date' | translate }}
      .table-x__header-col {{ 'base.status' | translate }}
    transition-group(name="fade")
      planning-table-row(:class="{ 'deleted': item.deleted }")(
        v-for="item in schedules"
        :key="item.id"
        :item="item")
</template>

<script>
import PlanningTableRow from './PlanningTableRow'

export default {
  name: 'PlanningTable',

  props: {
    schedules: {
      type: Array,
      required: true
    }
  },

  components: {
    PlanningTableRow
  }
}
</script>

<style lang="scss">
  .table-x__header-col,
  .table-x__row-col {
    &:nth-child(1) {
      width: 17%;
    }
    &:nth-child(2) {
      width: 12%;
    }
    &:nth-child(3) {
      width: 13%;
    }
    &:nth-child(4) {
      width: 15%;
    }
    &:nth-child(5) {
      width: 13%;
    }
  }

  .cow-wrapper {
    padding-top: 4rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    h2 {
      opacity: 0.8;
      font-size: 20px;
    }
  }

  .pig-404 {
    opacity: 0.45;
    height: 200px;
    width: 200px;
    background: url('../../../../../../assets/img/pig.svg') no-repeat center center;
  }
  .deleted {
    background-color: #FFC0B3 !important;
  }
</style>
